import axios from '@/api/axiosInstance';

export default async function getSubscription() {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API}/subscriptions/current`
  );
  return response.data;
}
